// i18next-extract-mark-ns-start Step1
import silk from '../../assets/order/fabrics/silk.jpg';
import jeans from '../../assets/order/fabrics/jeans.jpg';
import lace from '../../assets/order/fabrics/lace.jpg';
import leather from '../../assets/order/fabrics/leather.jpg';
import stitch from '../../assets/order/fabrics/stitch.jpg';
import other from '../../assets/order/fabrics/other.jpg';
import fur from '../../assets/order/fabrics/fur.jpg';
import sport from '../../assets/order/fabrics/sport.jpg';
import leatherAcce from '../../assets/order/accessories/leather.jpg';
import suede from '../../assets/order/accessories/suede.jpg';
import canvas from '../../assets/order/accessories/canvas.jpg';

export const TEXTILE_SLUG_PREFIX = 'textile_';

const fabrics = (t) => [
  { name: t('Jeans'), slug: 'jeans', image: jeans },
  { name: t('Soie ou mousseline'), slug: 'silk', image: silk },
  { name: t('Dentelle'), slug: 'lace', image: lace },
  { name: t('Maille'), slug: 'stitch', image: stitch },
  {
    name: t('Fourrure'),
    slug: 'fur',
    image: fur,
    filterContent: { title: t('Bientôt disponible'), text: t('Nous n’avons pas encore d’experts dans cette catégorie.') },
  },
  {
    name: t('Cuir'),
    slug: 'leather',
    image: leather,
    filterContent: {
      alwaysShowOnMobile: true,
      showOnHover: true,
      title: t('Attention !'),
      text: t(
        'Pour le moment, nous traitons que le cuir léger comme les hauts & pantalons (pas de blouson).',
      ),
    },
  },
  { name: t('Autre (coton, jersey...)'), slug: 'other', image: other },
  { name: t('Technique - Sport'), slug: 'bath', image: sport },
];

const accessoriesAndShoesFabrics = (t) => [
  { name: t('Cuir'), slug: 'leatherAcce', image: leatherAcce },
  { name: t('Daim / Nubuck'), slug: 'suede', image: suede },
  {
    name: t('Textile'), slug: 'textile', image: canvas,
  },
];

const accessoriesTextileFabrics = (t) => [
  { name: t('Jeans'), slug: `${TEXTILE_SLUG_PREFIX}jeans`, image: jeans },
  { name: t('Soie ou mousseline'), slug: `${TEXTILE_SLUG_PREFIX}silk`, image: silk },
  { name: t('Dentelle'), slug: `${TEXTILE_SLUG_PREFIX}lace`, image: lace },
  { name: t('Maille'), slug: `${TEXTILE_SLUG_PREFIX}stitch`, image: stitch },
  { name: t('Autre (coton, jersey...)'), slug: `${TEXTILE_SLUG_PREFIX}other`, image: other },
  { name: t('Technique - Sport'), slug: `${TEXTILE_SLUG_PREFIX}bath`, image: sport },
];

export const formatFabric = (fabric) => {
  if (fabric?.startsWith(TEXTILE_SLUG_PREFIX)) {
    return fabric.split('_')[1];
  }
  return fabric;
};

export const getDefaultFabric = (clothSlug) => {
  if (clothSlug === 'mail') {
    return 'bath';
  }
  if (clothSlug === 'ling') {
    return 'lingerie';
  }
  if (clothSlug === 'cost') {
    return 'suit';
  }
  return undefined;
};

export const getFabricSlug = (clothSlug, fabric) => {
  const formattedFabric = formatFabric(fabric?.length > 0 ? fabric : getDefaultFabric(clothSlug));
  return formattedFabric === 'other' ? undefined : fabric;
};

export function getFabricName(t, cloth) {
  if (!cloth.fabric) return null;
  const selectedFabric = getFabricSlug(cloth.slug, cloth.fabric);
  const fabricOptions = ['bag', 'wallet', 'belt'].includes(cloth.slug) ? accessoriesAndShoesFabrics(t) : fabrics(t);
  const fabric = fabricOptions.find((fabricIt) => fabricIt.slug === selectedFabric);
  return fabric?.name;
}

export const mustHideFabric = (fabric, piece) => (
  (fabric === 'leather' && piece === 'acce')
    || (fabric === 'fur' && ['haut', 'pant', 'robe', 'jupe'].includes(piece))
    || (fabric === 'bath' && ['robe', 'jupe'].includes(piece))
    || ((fabric === 'textile') && ['belt', 'wallet', 'flat_shoes', 'heeled_shoes', 'boots', 'heeled_boots'].includes(piece))
);

export function sortFabricsByOrder(fabricsOrder, t) {
  if (!fabricsOrder) return fabrics(t);

  return fabrics(t)
    .map((fabric, index) => ({ fabric, index }))
    .sort((a, b) => {
      const posA = fabricsOrder?.indexOf(a.fabric.slug);
      const posB = fabricsOrder?.indexOf(b.fabric.slug);
      if (posA === -1 && posB === -1) return a.index - b.index;
      if (posA === -1) return 1;
      if (posB === -1) return -1;
      return posA - posB;
    })
    .map((item) => item.fabric);
}

export { fabrics, accessoriesAndShoesFabrics, accessoriesTextileFabrics };
